import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceControl: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-control"><path d="M4.75 15V9L1 12L4.75 15Z" fill="currentColor"/><path d="M19.25 15V9L23 12L19.25 15Z" fill="currentColor"/><path d="M12 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVoiceControl;
